import * as React from 'react'

import { Text } from '~ui/components/typography/Text/Text'
import { TSingleSpace } from '~ui/styleGuide/spaces'

type TProps = RequiredChildren & {
  paddingLeft?: TSingleSpace
}

/**
 * Message that informs the customer about something or adds some context.
 */
export const FormInfoText: React.FC<TProps> = ({ children, paddingLeft = `small` }) => {
  return (
    <Text
      contrast={`low`}
      fontSize={`s14`}
      fontStyle={`lightItalic`}
      padding={{ left: paddingLeft, top: `none`, bottom: `none`, right: `none` }}
    >
      {children}
    </Text>
  )
}
